import React from "react";
import { useTranslation } from "react-i18next";

import Table from "../../../tables/components/Table";

import useUserLanguagesTableColumns from "./hooks/useUserLanguagesTableColumns";

export default function UserLanguagesTable({ user }) {
	const { t } = useTranslation();
	const userLanguagesTableColumns = useUserLanguagesTableColumns(user);

	const languages = Object.entries(user?.languages || {}).map(([code, { skill, dialect }]) => ({
		language: code,
		skill,
		dialect,
	}));

	return (
		<Table
			data={languages}
			columns={userLanguagesTableColumns}
			noDataAvailableMessage={t("noLanguagesAdded", "No languages added")}
		/>
	);
}
